import { UnitType } from '@exodus/currency'

const name = 'digibyte'
const displayName = 'DigiByte'
const ticker = 'DGB'
const displayTicker = ticker
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#2780E0'
const gradientColors = ['#2780E0', '#0065D3']
const gradientCoords = { x1: '-10.13%', y1: '-17.972%', x2: '0%', y2: '100%' }
const chainBadgeColors = gradientColors

const units = {
  satoshis: 0,
  DGB: 8,
}
const currency = UnitType.create(units)

const assetType = 'BITCOIN_LIKE'
const blockExplorer = {
  addressUrl: (address) => `https://digiexplorer.info/address/${address}`,
  txUrl: (txId) => `https://digiexplorer.info/tx/${txId}`,
}
const info = {
  description:
    'DigiByte is a cryptocurrency based on the Bitcoin protocol that wants to make mining accessible for everyday users again with five different proof-of-work algorithms to prevent miner centralization. It also supports faster transaction times and has been quick to implement innovative features like SegWit and smart contracts.',
  reddit: 'https://www.reddit.com/r/Digibyte/',
  twitter: 'https://twitter.com/DigiByteCoin',
  website: 'https://www.digibyte.co/',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
